import { ChecklistItem } from '@/src/common/modules/OnboardingChecklist/ChecklistItem'
import { Routes } from '@/src/experiences/card-benefits/navigation/routes'
import { useBenefitsEnrollments } from '@/src/experiences/card-benefits/hooks/useBenefitsEnrollments'

export function useBenefitsChecklistItem() {
  const { data: enrollmentsData, isLoading } = useBenefitsEnrollments()
  const isEnrolledInAnyBenefit =
    enrollmentsData?.some((enrollment) => enrollment.isEnrolled) || false

  if (isLoading) return 'loading'

  return isEnrolledInAnyBenefit ? null : (
    <ChecklistItem
      title="Enroll in Card Benefits"
      description="Receive over $800+ in value with Mesa Card benefits"
      status={'incomplete'}
      linkProps={{ href: Routes.Benefits.route }}
    />
  )
}
